module.exports = __webpack_public_path__ + "static/media/goddiva-main.e3af1b36.png";